<div class="modal-header">
    @if(isLoading || !orderView ){
      <h4 class="modal-title">Order Eye View</h4>
    }@else{
      <h4 class="modal-title">Order No. {{ orderView.orderNumber }}</h4>
    }
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

  @if(isLoading || !orderView){
    <h4>
      Loading...
    </h4>
  }@else{
    <div class="eye-view-grid-wrapper">
      <app-order-detail-box [orderNumber]="orderView.orderNumber" [orderDetails]="orderView.orderDetails"></app-order-detail-box>
      <div>
        <app-consignor-details-box [consignorDetails]="orderView.consignorDetails"></app-consignor-details-box>
        <app-consignee-details-box [consigneeDetails]="orderView.consigneeDetails"></app-consignee-details-box>
        <app-pallet-details-box [palletDetails]="orderView.palletDetails"></app-pallet-details-box>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>
